import script from "./TopView.vue?vue&type=script&setup=true&lang=js"
export * from "./TopView.vue?vue&type=script&setup=true&lang=js"

import "./TopView.vue?vue&type=style&index=0&id=24018961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24018961"]])

export default __exports__